import {updateFolderImgTrack, updateHeaderImgTrack, createTrack} from "../../../redux/Settings/tracksCrud";

export const setTemporaryErrorMessage = (setErrorMessage, message) => {
    setTimeout(() => {
        setErrorMessage("");
    }, 5000);
    setErrorMessage(message);
};

export const onTrackCreate = async ({t, name, headerImg, folderImg, actions}) => {
    const {setErrorMessage, updateTracks, showSuccessModal, hideLoader, showFailModal, closeCreateModal} = actions;

    const onSuccess = () => {
        updateTracks();
        showSuccessModal();
        hideLoader();
        closeCreateModal();
    };
    const onCreateTrackError = msg => {
        setErrorMessage(msg);
        showFailModal();
        hideLoader();
    };
    const onImageUploadError = msg => {
        setErrorMessage(msg);
        updateTracks();
        showFailModal();
        hideLoader();
        closeCreateModal();
    };

    try {
        const created = await createTrack({name});
        if (created && created.result === "success" && created.data && created.data.track_id) {
            const addedFolderImg = await updateFolderImgTrack({
                id: created.data.track_id,
                file: folderImg,
            });

            if (addedFolderImg && addedFolderImg.result && addedFolderImg.result === "success") {
                const addedHeaderImg = await updateHeaderImgTrack({
                    id: created.data.track_id,
                    file: headerImg,
                });

                if (addedHeaderImg && addedHeaderImg.result && addedHeaderImg.result === "success") {
                    onSuccess();
                } else {
                    let errorMessage = t("MODAL.CREATE_TRACK.FAIL_HEADERIMG");
                    onImageUploadError(errorMessage);
                }
            } else {
                let errorMessage = t("MODAL.CREATE_TRACK.FAIL_THUMBNAIL");
                onImageUploadError(errorMessage);
            }
        } else {
            let errorMessage = t("MODAL.CREATE_TRACK.FAIL_CREATE");
            onCreateTrackError(errorMessage);
        }
    } catch (err) {
        onCreateTrackError(err.message);
    }
};
